module.exports = __webpack_public_path__ + "static/media/button.3cecf6ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/button.png
// module id = 5
// module chunks = 0